module.exports = __webpack_public_path__ + "static/wifi-1858e6af6e4f7fab8b37d5ed4edf939a.jpg";